module.exports = __webpack_public_path__ + "img/j.d10ebb12.jpg";